export default __webpack_public_path__ + "static/media/005-acorn.18934f19.svg";